import React from 'react';
import includes from 'lodash/includes';
import PropTypes from 'prop-types';
import { Collapse, Col } from 'antd';
import { flattenDocs } from '../../utils';
import { isNil } from 'lodash';

import { Download, TextField, RadioGroup } from 'components';
const { Panel } = Collapse;

const DownloadedItems = ({ content, subgroupName, docs, subdocs, subgroup, docItems }) => {

  console.log("DOCS", docs)

  return (
    <>
        <div className="file-download-container">
        <p className="mt-6 mr-0 color-blue-3 text-bold font-size-24">
          Δικαιολογητικά        
      </p> 
          {/* {content.map((c, index) =>
            includes(
              docs
                .filter(d => d)
                .filter(d => d.field)
                .map(d => d.field),
              c.fileCode
            ) ? (
              <Download
                key={index}
                description={c.label}
                file={docs.filter(d => d).filter(d => d.field === c.fileCode)}
              />
            ) : null
          )} */}
          {content.map((c, index) => {
            const matchedFile = docs?.find(d => d.items?.[0]?.field === c.fileCode);

            // console.log("matched", matchedFile)

            return matchedFile ? (
              <Download
                key={index}
                description={c.label}
                file={matchedFile.items}
              />
            ) : null;
          })}
      </div>  
    </>
  );
};

DownloadedItems.propTypes = {
  content: PropTypes.array.isRequired,
  docs: PropTypes.array.isRequired,
};

export default DownloadedItems;
